import React from 'react'

import {
  AlignItems,
  Box,
  Color,
  Display,
  Icon,
  IconVariant,
  JustifyContent,
  Space,
  Text,
} from '@gousto-internal/citrus-react'

import { ERROR_COMPONENT_MODES, InstrumentedErrorComponent } from '@library/browser-errors'
import { BROWSER_ERROR_KEYS } from '@library/observability/browser'

import { signupConfig } from 'routes/Signup/signupConfig'

function ErrorText(props: { children: string }) {
  const { children } = props

  return (
    <Box
      display={Display.Flex}
      alignItems={AlignItems.Center}
      justifyContent={JustifyContent.Center}
      color={Color.Error_900}
      data-testid="PostcodeStepMessage"
    >
      <Text size={3}>{children}</Text>
    </Box>
  )
}

function DefaultText(props: { children: string }) {
  const { children } = props

  return (
    <Box
      display={Display.Flex}
      alignItems={AlignItems.Center}
      justifyContent={JustifyContent.Center}
      color={Color.Success_600}
      data-testid="PostcodeStepMessage"
    >
      <Icon name="tick" variant={IconVariant.Inherit} />
      <Space direction="horizontal" size={1} />
      <Text size={3}>{children}</Text>
    </Box>
  )
}

export const PostcodeStepMessage = ({ deliveryDaysError }: { deliveryDaysError: string }) => {
  const footNote = signupConfig.postCodeStep.footNoteMessage
  let text = signupConfig.postCodeStep.reminder
  let isFootnoteVisible = true
  if (deliveryDaysError === 'do-not-deliver') {
    text = signupConfig.postCodeStep.doNotDeliverErrorMessage
    isFootnoteVisible = false
  } else if (deliveryDaysError) {
    text = signupConfig.postCodeStep.genericErrorMessage
    isFootnoteVisible = false
  }

  return (
    <>
      {deliveryDaysError ? (
        <InstrumentedErrorComponent
          mode={ERROR_COMPONENT_MODES.ON_RENDER}
          errorKey={BROWSER_ERROR_KEYS.POSTCODE_WIZARD_ERROR}
          message={text}
          footnote={footNote}
          cause={deliveryDaysError}
        >
          <ErrorText>{text}</ErrorText>
        </InstrumentedErrorComponent>
      ) : (
        <DefaultText>{text}</DefaultText>
      )}

      {isFootnoteVisible && (
        <>
          <Space direction="vertical" size={6} />
          <Box
            display={Display.Flex}
            alignItems={AlignItems.Center}
            justifyContent={JustifyContent.Center}
            color={Color.ColdGrey_500}
            data-testid="PostcodeStepFootnote"
          >
            <Text size={1}>{footNote}</Text>
          </Box>
        </>
      )}
    </>
  )
}
